<template>
    <rkm-area
        title="Classificação de cadastro"
        type="fieldset"
    >
        <template v-slot:trailing>
            <rkm-icon
                icon="info"
                color="secondary"
                class="infor"
                small
                v-rkm-popover.hover.right="{
                    html: true,
                    content: 'Marque as opções abaixo para liberar o agendamento para pacientes com classificação Provisório e/ou Outro Município.'
                }"
            />
        </template>

        <rkm-row>
            <rkm-col cols="1">
                <rkm-form-checkbox v-model="data.model.classificacaoCadastro.permiteProvisorio">
                    Provisório
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-checkbox v-model="data.model.classificacaoCadastro.permiteOutroMunicipio">
                    Outro município
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    props: {
        data: { required: true, type: Object },
    },
}
</script>

<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
    }
</style>
